module.exports = __webpack_public_path__ + "img/20@2x.f49400f8.png";